(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-restore"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollTicking = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      const announcementHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;
      const headerHeight = this.header.offsetHeight;

      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);
      document.documentElement.style.setProperty('--header-group-height', `${headerHeight + announcementHeight}px`);
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${Math.round(this.header.getBoundingClientRect().bottom)}px`
      );
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }

    setAnnouncementHidden(isHidden) {
      if (!this.announcementBar) return;
      this.announcementBar.classList.toggle('tt-header-announcement-hidden', isHidden);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.scrollTicking) return;

      this.scrollTicking = true;
      requestAnimationFrame(() => {
        this.onScrollTick();
        this.scrollTicking = false;
      });
    }

    onScrollTick() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollDelta = scrollTop - this.currentScrollTop;

      if (document.documentElement.classList.contains('tt-header-overlay-open')) {
        this.preventHide = true;
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (scrollDelta < 6) {
          this.currentScrollTop = scrollTop;
          return;
        }

        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (scrollDelta > -6) {
          this.currentScrollTop = scrollTop;
          return;
        }

        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.hide();
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header.classList.contains('shopify-section-header-hidden')) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      requestAnimationFrame(() => {
        this.header.classList.add('shopify-section-header-hidden');
        this.setAnnouncementHidden(true);
      });
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (!this.header.classList.contains('shopify-section-header-hidden')) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      requestAnimationFrame(() => {
        this.header.classList.remove('shopify-section-header-hidden');
        this.setAnnouncementHidden(false);
      });
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.setAnnouncementHidden(false);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function initMobileMenuDrawerFallback() {
    const drawer = document.querySelector('#Details-menu-drawer-container');
    if (!drawer) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const syncMenuState = () => {
      const sectionHeader = document.querySelector('.section-header');
      const open = Boolean(drawer.open) && drawer.classList.contains('menu-opening');
      document.documentElement.classList.toggle('tt-nav-open', open);
      if (open) {
        sectionHeader?.classList.add('menu-open');
        document.body.classList.add('overflow-hidden-tablet');
      } else {
        sectionHeader?.classList.remove('menu-open');
        document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile');
        document.documentElement.classList.remove('tt-nav-open');
      }
    };

    const addOpeningAfterPaint = (detailsEl) => {
      if (!detailsEl) return;
      if (reducedMotion.matches) {
        detailsEl.classList.add('menu-opening');
        syncMenuState();
        return;
      }
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (detailsEl.open) detailsEl.classList.add('menu-opening');
          syncMenuState();
        });
      });
    };

    const whenHeaderDrawerReady = (fn) => {
      if (customElements.get('header-drawer')) {
        fn();
        return;
      }
      customElements.whenDefined('header-drawer').then(fn);
    };

    whenHeaderDrawerReady(() => {
      const HeaderDrawer = customElements.get('header-drawer');
      if (!HeaderDrawer || HeaderDrawer.prototype.__ttSmoothOpen) return;
      HeaderDrawer.prototype.__ttSmoothOpen = true;
      HeaderDrawer.prototype.openMenuDrawer = function (summaryElement) {
        this.header = this.header || document.querySelector('.section-header');
        this.borderOffset =
          this.borderOffset ||
          (this.closest('.header-wrapper')?.classList.contains('header-wrapper--border-bottom') ? 1 : 0);
        document.documentElement.style.setProperty(
          '--header-bottom-position',
          `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset, 10)}px`
        );
        this.header.classList.add('menu-open');
        summaryElement.setAttribute('aria-expanded', true);
        window.addEventListener('resize', this.onResize);
        if (typeof trapFocus === 'function') trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
        addOpeningAfterPaint(this.mainDetailsToggle);
      };
    });

    drawer.addEventListener('toggle', () => {
      if (drawer.open) {
        if (!customElements.get('header-drawer')) addOpeningAfterPaint(drawer);
        return;
      }
      syncMenuState();
    });
    new MutationObserver(syncMenuState).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    drawer.querySelector('.tt-drawer-bar__close')?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!drawer.open) return;
      const headerDrawer = drawer.closest('header-drawer');
      const summary = drawer.querySelector('summary.header__icon--menu');
      if (headerDrawer && typeof headerDrawer.closeMenuDrawer === 'function') {
        headerDrawer.closeMenuDrawer(event, summary);
      } else {
        drawer.classList.remove('menu-opening');
        drawer.removeAttribute('open');
      }
      syncMenuState();
    });
    syncMenuState();
  })();

  // Touch screens have no hover, so the dropdown would otherwise be unreachable.
  (function initHeaderNavToggles() {
    const toggles = document.querySelectorAll('[data-tt-nav-toggle]');
    if (!toggles.length) return;

    const coarsePointer = window.matchMedia('(hover: none)');

    const setOpen = (item, open) => {
      if (!item) return;
      item.classList.toggle('is-open', open);
      const toggle = item.querySelector('[data-tt-nav-toggle]');
      if (toggle?.hasAttribute('aria-expanded')) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    const closeAll = (except) => {
      document.querySelectorAll('.ff-header-nav__item--has-dropdown.is-open, .ff-header-nav__item--mega.is-open').forEach((item) => {
        if (item !== except) setOpen(item, false);
      });
    };

    toggles.forEach((toggle) => {
      const item = toggle.closest('.ff-header-nav__item--has-dropdown, .ff-header-nav__item--mega');
      if (!item) return;

      toggle.addEventListener('click', (event) => {
        const open = item.classList.contains('is-open');
        // A parent that links somewhere keeps navigating on desktop, where hover already reveals
        // the menu. On touch the first tap opens it instead, and the second tap follows the link.
        if (toggle.tagName === 'A' && (!coarsePointer.matches || open)) return;

        event.preventDefault();
        closeAll(item);
        setOpen(item, !open);
      });

      item.addEventListener('mouseenter', () => {
        if (coarsePointer.matches) return;
        if (toggle.hasAttribute('aria-expanded')) toggle.setAttribute('aria-expanded', 'true');
      });

      item.addEventListener('focusin', () => {
        if (toggle.hasAttribute('aria-expanded')) toggle.setAttribute('aria-expanded', 'true');
      });

      item.addEventListener('focusout', (event) => {
        if (item.contains(event.relatedTarget)) return;
        if (coarsePointer.matches && item.classList.contains('is-open')) return;
        if (toggle.hasAttribute('aria-expanded')) toggle.setAttribute('aria-expanded', 'false');
      });

      // A pointer user who opened it by clicking still expects it to close on the way out.
      item.addEventListener('mouseleave', () => {
        if (coarsePointer.matches) return;
        setOpen(item, false);
      });
    });

    document.addEventListener('pointerdown', (event) => {
      const openItem = document.querySelector('.ff-header-nav__item--has-dropdown.is-open, .ff-header-nav__item--mega.is-open');
      if (openItem && openItem.contains(event.target)) return;
      closeAll();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = document.querySelector('.ff-header-nav__item--has-dropdown.is-open, .ff-header-nav__item--mega.is-open');
      if (!open) return;
      setOpen(open, false);
      open.querySelector('[data-tt-nav-toggle]')?.focus();
    });
  })();

  (function initHeaderMegaScrollLock() {
    if (window.__ttHeaderMegaScrollLock) return;
    window.__ttHeaderMegaScrollLock = true;

    const html = document.documentElement;
    const desktopNav = window.matchMedia('(min-width: 990px)');
    const scrollKeys = new Set([' ', 'PageDown', 'PageUp', 'ArrowDown', 'ArrowUp', 'Home', 'End']);
    let locked = false;

    const isOverlayOpen = () => {
      if (!desktopNav.matches) return false;
      return Boolean(
        document.querySelector(
          '.ff-header-nav__item--mega:hover, .ff-header-nav__item--mega:focus-within, .ff-header-nav__item--mega.is-open'
        )
      );
    };

    const preventScroll = (event) => {
      if (!locked) return;
      event.preventDefault();
    };

    const preventKeys = (event) => {
      if (!locked || event.altKey || event.ctrlKey || event.metaKey) return;
      if (scrollKeys.has(event.key)) event.preventDefault();
    };

    const setLocked = (open) => {
      if (open === locked) return;
      locked = open;
      html.classList.toggle('tt-header-overlay-open', open);

      const sticky = document.querySelector('sticky-header');
      const section = document.querySelector('.section-header');
      if (sticky) sticky.preventHide = open;
      if (open) {
        section?.classList.add('menu-open');
      } else if (!document.querySelector('#Details-menu-drawer-container.menu-opening')) {
        section?.classList.remove('menu-open');
      }

      if (open) {
        const stickyEl = document.querySelector('sticky-header');
        if (stickyEl && typeof stickyEl.setHeaderHeight === 'function') stickyEl.setHeaderHeight();
        window.addEventListener('wheel', preventScroll, { passive: false });
        window.addEventListener('touchmove', preventScroll, { passive: false });
        window.addEventListener('keydown', preventKeys);
      } else {
        window.removeEventListener('wheel', preventScroll);
        window.removeEventListener('touchmove', preventScroll);
        window.removeEventListener('keydown', preventKeys);
      }
    };

    const sync = () => setLocked(isOverlayOpen());

    document.addEventListener('mouseover', (event) => {
      const next = event.target.closest?.('.ff-header-nav__item--mega');
      const prev = event.relatedTarget?.closest?.('.ff-header-nav__item--mega');
      if (next && !prev) sync();
    });
    document.addEventListener('mouseout', (event) => {
      const prev = event.target.closest?.('.ff-header-nav__item--mega');
      const next = event.relatedTarget?.closest?.('.ff-header-nav__item--mega');
      if (prev && !next) requestAnimationFrame(sync);
    });
    document.addEventListener('focusin', sync);
    document.addEventListener('focusout', () => setTimeout(sync));
    desktopNav.addEventListener('change', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollTicking = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      const announcementHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;
      const headerHeight = this.header.offsetHeight;

      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);
      document.documentElement.style.setProperty('--header-group-height', `${headerHeight + announcementHeight}px`);
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${Math.round(this.header.getBoundingClientRect().bottom)}px`
      );
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }

    setAnnouncementHidden(isHidden) {
      if (!this.announcementBar) return;
      this.announcementBar.classList.toggle('tt-header-announcement-hidden', isHidden);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.scrollTicking) return;

      this.scrollTicking = true;
      requestAnimationFrame(() => {
        this.onScrollTick();
        this.scrollTicking = false;
      });
    }

    onScrollTick() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollDelta = scrollTop - this.currentScrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (scrollDelta < 6) {
          this.currentScrollTop = scrollTop;
          return;
        }

        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (scrollDelta > -6) {
          this.currentScrollTop = scrollTop;
          return;
        }

        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.hide();
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header.classList.contains('shopify-section-header-hidden')) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      requestAnimationFrame(() => {
        this.header.classList.add('shopify-section-header-hidden');
        this.setAnnouncementHidden(true);
      });
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (!this.header.classList.contains('shopify-section-header-hidden')) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      requestAnimationFrame(() => {
        this.header.classList.remove('shopify-section-header-hidden');
        this.setAnnouncementHidden(false);
      });
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.setAnnouncementHidden(false);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function initMobileMenuDrawerFallback() {
    const drawer = document.querySelector('#Details-menu-drawer-container');
    if (!drawer) return;

    const overlaySelectors = [
      '.tt-product-6011-hero__media-actions',
      '.tt-product-6011-hero__media-action',
      '.tt-product-6011-hero__thumbs-prev',
      '.tt-product-6011-hero__thumbs-next',
      '.tt-product-6011-hero__badge',
      '.tt-product-6011-hero__3d-zoom',
    ];

    const syncMenuState = () => {
      const sectionHeader = document.querySelector('.section-header');
      const main = document.getElementById('MainContent');
      const open = Boolean(drawer.open);
      document.documentElement.classList.toggle('tt-nav-open', open);
      if (open) {
        drawer.classList.add('menu-opening');
        sectionHeader?.classList.add('menu-open');
        document.body.classList.add('overflow-hidden-tablet');
        if (main) {
          main.setAttribute('inert', '');
          main.style.setProperty('visibility', 'hidden', 'important');
        }
        overlaySelectors.forEach((sel) => {
          document.querySelectorAll(sel).forEach((el) => {
            el.style.setProperty('display', 'none', 'important');
            el.style.setProperty('backdrop-filter', 'none', 'important');
            el.style.setProperty('-webkit-backdrop-filter', 'none', 'important');
          });
        });
      } else {
        drawer.classList.remove('menu-opening');
        sectionHeader?.classList.remove('menu-open');
        document.body.classList.remove('overflow-hidden-tablet');
        document.documentElement.classList.remove('tt-nav-open');
        if (main) {
          main.removeAttribute('inert');
          main.style.removeProperty('visibility');
        }
        overlaySelectors.forEach((sel) => {
          document.querySelectorAll(sel).forEach((el) => {
            el.style.removeProperty('display');
            el.style.removeProperty('backdrop-filter');
            el.style.removeProperty('-webkit-backdrop-filter');
          });
        });
      }
    };

    drawer.addEventListener('toggle', syncMenuState);
    syncMenuState();
  })();

  } catch(e) { console.error(e); }
})();
})();
